export const isDuplicate = (sumbittedVin, vins) => {
  const currentVins = vins.map(({ vin }) => vin)
  return currentVins.includes(sumbittedVin)
}
